import { useTranslation } from 'react-i18next';

import { Dialog } from 'primereact/dialog';
import { Tag } from 'primereact/tag';
import { Timeline } from 'primereact/timeline';

import PropTypes from 'prop-types';
import { formatDatetime, toCamelCaseString } from 'utils/func';
import { projectLogColorMapping } from 'constant';
import React from 'react';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(timezone);
dayjs.extend(utc);

function ViewHistory({ data, visible, setVisible, title }) {
  const { t } = useTranslation();

  const formatAction = ({ actionType }) => (
    <Tag
      style={{ background: projectLogColorMapping[toCamelCaseString(actionType)] }}
      value={t(`projectProposal.viewHistory.status.${toCamelCaseString(actionType)}`)}
      rounded
    />
  );
  const formatCreatedAt = ({ createdAt }) => (
    <small className="text-color-secondary">{formatDatetime(createdAt, 'HH:mm DD/MM/YYYY')}</small>
  );

  return (
    <Dialog
      header={<p className="text-blue-500">{title}</p>}
      visible={visible}
      position="center"
      style={{ width: '500px' }}
      onHide={() => setVisible(false)}
      draggable={false}
    >
      <Timeline value={data} opposite={formatAction} content={formatCreatedAt} />
    </Dialog>
  );
}

export default React.memo(ViewHistory);

ViewHistory.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};
